<div class="card page-card home-page">
  <div class="card-body home-page__body">
    <section class="home-page__hero-grid" [class.home-page__hero-grid--solo]="!hasHeroAside">
      <div class="home-page__hero" [class.home-page__hero--returning]="isAuthenticated">
        @if (isAuthenticated) {
          <h2 class="home-page__title">{{ returningTitle }}</h2>
          <p class="home-page__lede">{{ returningDescription }}</p>
        } @else {
          <h2 class="home-page__title">Welcome to the Community Resource Directory.</h2>
          <p class="home-page__lede">
            Use this site to learn about the directory, register your agency, manage provider accounts, and find help for
            setup and ongoing use.
          </p>

          <section class="home-page__feature-update" aria-labelledby="home-page-feature-title">
            <div class="home-page__feature-intro">
              <p class="home-page__feature-eyebrow">New sign-in experience</p>
              <h3 id="home-page-feature-title" class="home-page__feature-heading">
                More secure. Easier to use anywhere.
              </h3>
            </div>

            <div class="home-page__feature-grid">
              <article class="home-page__feature-card home-page__feature-card--mfa">
                <div class="home-page__feature-header">
                  <span class="home-page__feature-icon" aria-hidden="true">
                    <fa-icon [icon]="faShieldHalved"></fa-icon>
                  </span>
                  <h4 class="home-page__feature-title">Multi-factor authentication</h4>
                </div>

                <p class="home-page__feature-description">
                  CRD now requires MFA. At your next sign-in, have your phone ready to set up an authenticator app.
                </p>

                <a
                  class="home-page__feature-link"
                  [href]="firstTimeSignInInstructionsUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View first-time sign-in instructions
                  <fa-icon [icon]="faArrowUpRightFromSquare" aria-hidden="true"></fa-icon>
                </a>
                <div class="home-page__mfa-help">
                  <p class="home-page__feature-description"><strong>New phone or code not working?</strong></p>
                  <a
                    class="home-page__feature-link"
                    routerLink="/faq"
                  >
                    <span>View MFA help in the FAQ</span>
                    <fa-icon [icon]="faChevronRight" aria-hidden="true"></fa-icon>
                  </a>
                </div>
              </article>

              <article class="home-page__feature-card home-page__feature-card--mobile">
                <div class="home-page__feature-header">
                  <span class="home-page__feature-icon" aria-hidden="true">
                    <fa-icon [icon]="faMobileScreen"></fa-icon>
                  </span>
                  <h4 class="home-page__feature-title">Mobile Friendly</h4>
                </div>

                <p class="home-page__feature-description">
                  The site now adapts to your phone or tablet, making CRD easier to use away from a desktop.
                </p>
              </article>
            </div>
          </section>
        }
      </div>

      @if (!isAuthenticated) {
        <div class="home-page__actions">
          @for (action of actionCards; track action.route) {
            <article [class]="'home-page__action-card home-page__action-card--' + action.tone">
              <div class="home-page__action-header">
                <span class="home-page__icon-badge">
                  <fa-icon [icon]="action.icon"></fa-icon>
                </span>

                <h3 class="home-page__action-title">{{ action.title }}</h3>
              </div>

              <p class="home-page__action-description">{{ action.description }}</p>

              <div class="home-page__action-footer">
                <a [class]="'btn home-page__action-button ' + action.buttonClass" [routerLink]="action.route">
                  {{ action.buttonLabel }}
                </a>
              </div>
            </article>
          }
        </div>
      } @else if (showReferralQuickLaunch) {
        <aside class="home-page__quick-panel">
          <div class="home-page__quick-copy">
            <h3 class="home-page__quick-title">Referral quick launch</h3>
          </div>

          <div class="home-page__quick-list">
            @for (link of quickLaunchLinks; track link.route) {
              <a class="home-page__quick-item" [routerLink]="link.route">
                <!--<span class="home-page__quick-badge">{{ link.badge }}</span>-->
                <span class="home-page__quick-item-copy">
                  <span class="home-page__quick-item-title">{{ link.title }}</span>
                  <span class="home-page__quick-item-description">{{ link.description }}</span>
                </span>
                <span class="home-page__quick-arrow" aria-hidden="true"><fa-icon [icon]="faChevronRight"></fa-icon></span>
              </a>
            }
          </div>
        </aside>
      }
    </section>

    @if (accountStatusNotice$ | async; as notice) {
      <section
        [class]="'home-page__status-notice home-page__status-notice--' + notice.tone"
        aria-label="Account status guidance"
      >
        <div class="home-page__status-copy">
          <p class="home-page__status-eyebrow">Account status</p>
          <h3 class="home-page__status-title">{{ notice.title }}</h3>
          <p class="home-page__status-description">{{ notice.description }}</p>
        </div>

        <a class="home-page__status-link" [routerLink]="notice.route">
          {{ notice.linkLabel }}
          <fa-icon [icon]="faChevronRight"></fa-icon>
        </a>
      </section>
    }

    <section class="home-page__resources">
      @for (resource of resourceCards; track resource.title) {
        <article [class]="'home-page__resource-card home-page__resource-card--' + resource.tone">
          <div class="home-page__resource-copy">
            <div class="home-page__resource-header">
              <span class="home-page__icon-badge">
                <fa-icon [icon]="resource.icon"></fa-icon>
              </span>

              <h3 class="home-page__resource-title">{{ resource.title }}</h3>
            </div>

            <p class="home-page__resource-description">{{ resource.description }}</p>
          </div>

          <div class="home-page__resource-links">
            @for (link of resource.links; track link.label) {
              @if (link.url) {
                <a [href]="link.url" target="_blank" rel="noopener noreferrer">
                  {{ link.label }}
                </a>
              } @else {
                <a [routerLink]="link.route">
                  {{ link.label }}
                </a>
              }
            }
          </div>
        </article>
      }
    </section>
  </div>
</div>
